import { getStoreCurrencySymbol } from "../../../../../../../utils/currency";

export function getInitials(name = "") {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export function formatCurrency(val) {
  if (val == null || val === "" || isNaN(val)) return "N/A";
  return `${getStoreCurrencySymbol()} ${Number(val).toLocaleString("en-IN")}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return "N/A";
  const d = new Date(dateStr);
  if (isNaN(d)) return "N/A";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}
